/**
 * slack_read_dm — canonical manifest (zero imports, shared with tool-runtime).
 *
 * Reads the message history of a specific DM conversation.
 * Used during contact enrichment and for context before drafting outreach.
 */

export const MANIFEST = {
  name: 'slack_read_dm',
  description: `Read message history from a Slack DM conversation.

**INTEGRATION REQUIRED:** User must connect a Slack workspace in Settings → Integrations first.

**USE CASES:**
- Read conversation history before drafting a follow-up
- Enrich a Contact with recent Slack interactions
- Understand the relationship context with someone

**EXAMPLES:**

Read DMs with a Slack user:
{ "slackUserId": "U012AB3CD" }

Read from a specific workspace with more messages:
{ "slackUserId": "U012AB3CD", "workspaceId": "T012AB3CD", "limit": 30 }

**RETURNS:**
Array of { ts, tsIso, text, direction ("inbound"|"outbound"), senderId, workspaceId }
direction is "outbound" if the authenticated user sent the message, "inbound" otherwise.`,
  inputSchema: {
    type: 'object' as const,
    properties: {
      slackUserId: {
        type: 'string',
        description: 'Slack user ID (U...) of the person whose DM history to read',
      },
      workspaceId: {
        type: 'string',
        description: 'Slack team ID (T...) of the workspace. Omit to use any connected workspace.',
      },
      limit: {
        type: 'number',
        description: 'Number of messages to return (1–100, default 20)',
      },
    },
    required: ['slackUserId'],
  },
} as const;
